import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { shareService } from '../services/shareService';

export function useRotateLinkToken() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('shares');

  return useMutation({
    mutationFn: (id: string) => shareService.rotateToken(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shares'] });
      toast.success({ title: t('toasts.rotateSuccess') });
    },
    onError: () => {
      toast.danger({ title: t('toasts.rotateError') });
    },
  });
}
